import { useChatStore } from '@/hooks/useChatStore';
import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import ChatPage from '@/pages/chat/ChatPage';

const ChatWrapper = (props: any) => {
  const { chatId } = useParams();

  const {
    setError,
    setLoading,
    setChatId,
    hasUnprocessedMessage,
    clearChatHistory,
  } = useChatStore();
  const [remountKey, setRemountKey] = useState(0);
  const previousChatIdRef = useRef<string | null>(null);

  // Handle chat ID changes
  useEffect(() => {
    // Only run if the chatId has actually changed
    if (chatId !== previousChatIdRef.current) {
      // Only clear chat history if there are no unprocessed messages
      if (!hasUnprocessedMessage) {
        // setChatHistory([]);
        setError(null);
        setLoading(true);
        clearChatHistory();

        if (chatId) {
          setChatId(chatId);
        }
      }
      // Only remount if we're not in the middle of processing a message
      // or if we're navigating to a completely different chat
      if (!hasUnprocessedMessage || (chatId && previousChatIdRef.current)) {
        setRemountKey((prev) => prev + 1);
      }

      previousChatIdRef.current = chatId || null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatId]);

  // Handle redirect to today's conversation if needed
  // if (todayConversation && !chatId) {
  //   return (
  //     <Navigate to={`/chat/${todayConversation.messages[0].id}`} replace />
  //   );
  // }

  // Use the remountKey to force a complete remount of the ChatPage
  return (
    <Box key={`chat-wrapper-${remountKey}`} data-testid="chat-wrapper">
      <ChatPage
        key={`chat-page-${remountKey}`}
        {...props}
        chatId={chatId}
        data-testid="chat-page"
      />
    </Box>
  );
};

export default ChatWrapper;
